import { render, staticRenderFns } from "./labelTaskAdmin.vue?vue&type=template&id=0805d1d7&scoped=true&"
import script from "./labelTaskAdmin.vue?vue&type=script&lang=js&"
export * from "./labelTaskAdmin.vue?vue&type=script&lang=js&"
import style0 from "./labelTaskAdmin.vue?vue&type=style&index=0&id=0805d1d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805d1d7",
  null
  
)

export default component.exports